
import { GET_SCHEDULES, GET_SCHEDULES_SUCCESS, GET_SCHEDULES_FAILURE, GET_ELEGIBILITIES, GET_ELEGIBILITIES_SUCCESS, GET_ELEGIBILITIES_FAILURE } from "../constants";

const initialState = {
    loader: false,
    scheduleData: [],
    elegibilityData: [],
    scheduleError: false,
    elegibilityError: false
}

export default function SettingReducer(state = initialState, action) {
    switch (action.type) {
        case GET_SCHEDULES:
            state = {
                ...state,
                loader: true,
            }
            break;

        case GET_SCHEDULES_SUCCESS:
            state = {
                ...state,
                loader: false,
                scheduleData: action.payload,
                scheduleError: false
            }
            break;

        case GET_SCHEDULES_FAILURE:
            state = {
                ...state,
                loader: false,
                scheduleData: action.payload ? [] : state.scheduleData,
                scheduleError: !!action.payload,
            }
            break;

        case GET_ELEGIBILITIES:
            state = {
                ...state,
                loader: true
            }
            break;

        case GET_ELEGIBILITIES_SUCCESS:
            state = {
                ...state,
                loader: false,
                elegibilityData: action.payload,
                elegibilityError: false
            }
            break;

        case GET_ELEGIBILITIES_FAILURE:
            state = {
                ...state,
                loader: false,
                elegibilityData: action.payload ? [] : state.elegibilityData,
                elegibilityError: !!action.payload,
            }
            break;

        default:
            break;
    }
    return state;
}